import { render, staticRenderFns } from "./printViewBtn.vue?vue&type=template&id=12c5be2c&scoped=true&"
import script from "./printViewBtn.vue?vue&type=script&lang=js&"
export * from "./printViewBtn.vue?vue&type=script&lang=js&"
import style0 from "./printViewBtn.vue?vue&type=style&index=0&id=12c5be2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c5be2c",
  null
  
)

export default component.exports